import { Column, Row } from 'Components/Grid';
import { CardStyled, RowExhibition, SubTitleModalDetail, TitleModalDetail } from '../styles';
import { useTranslation } from 'react-i18next';

export const CookiesDetail = ({ name, cookies }) => {
  const { t } = useTranslation(['cookies']);
  const convertExpires = expires => {
    if (expires === -1) {
      return t('cookies:show.cookiesDetail.session');
    } else if (Number((expires / 1000).toFixed(0)) < 60) {
      return t('cookies:show.cookiesDetail.seconds', { count: Number((expires / 1000).toFixed(0)) });
    } else if (Number((expires / 60000).toFixed(0)) < 60) {
      return t('cookies:show.cookiesDetail.minutes', { count: Number((expires / 60000).toFixed(0)) });
    } else if (Number((expires / 3600000).toFixed(0)) < 24) {
      return t('cookies:show.cookiesDetail.hours', { count: Number((expires / 3600000).toFixed(0)) });
    } else {
      const days = Number((expires / 3600000).toFixed(0)) / 24;
      return t('cookies:show.cookiesDetail.days', { count: days.toFixed(0) });
    }
  };
  return (
    <>
      <Row className="mb-3">
        <Column xs={1} flex className="justify-content-center align-items-start px-0">
          <div
            className="swal2-icon swal2-info swal2-icon-show"
            style={{
              display: 'flex',
              height: '1.5rem',
              width: '1.5rem',
              margin: '0',
            }}
          >
            <div className="swal2-icon-content" style={{ fontSize: '1.5rem' }}>
              i
            </div>
          </div>
        </Column>
        <Column>
          <TitleModalDetail>{t('cookies:show.cookiesDetail.title', { name })}</TitleModalDetail>
          <SubTitleModalDetail>{t('cookies:show.cookiesDetail.subtitle')}</SubTitleModalDetail>
        </Column>
      </Row>
      <div
        style={{
          height: '165px',
          overflowY: 'auto',
        }}
      >
        {cookies.map((cookie, index) => (
          <CardStyled className="mb-2" key={index}>
            <RowExhibition>
              <Column className="font-weight-bold" xs={4}>
                {t('cookies:show.cookiesDetail.nameLabel')}
              </Column>
              <Column>{cookie?.name}</Column>
            </RowExhibition>
            <RowExhibition>
              <Column className="font-weight-bold" xs={4}>
                {t('cookies:show.cookiesDetail.expiresLabel')}
              </Column>
              <Column>{convertExpires(cookie?.expires)}</Column>
            </RowExhibition>
            <RowExhibition>
              <Column className="font-weight-bold" xs={4}>
                {t('cookies:show.cookiesDetail.regionLabel')}
              </Column>
              <Column>{cookie?.region}</Column>
            </RowExhibition>
            <RowExhibition>
              <Column className="font-weight-bold" xs={4}>
                {t('cookies:show.cookiesDetail.blockedLabel')}
              </Column>
              <Column>{cookie?.auto_block ? t('cookies:show.cookiesDetail.blockedYes') : t('cookies:show.cookiesDetail.blockedNo')}</Column>
            </RowExhibition>
          </CardStyled>
        ))}
      </div>
    </>
  );
};
